<template>
  <div>

    <template v-if="showSelectedReport">
      <template v-if="selectedInsight">
        <explore-insight :insight="selectedInsight"></explore-insight>
      </template>
      <template v-else>
        <div class="w-100" style="padding: 150px 0;">
          <spinner size="large"></spinner>
        </div>
      </template>
    </template>

    <template v-else>
      <template v-if="currentFacet === 'all'">
        <h2>{{type}}</h2>
        <div v-if="insightsToShow.length > 0">
          <b-nav v-for="(insight, index) in insightsToShow" :key="insight.flag">
            <b-nav-item :title="insight.title" @click="goToReport(insight)">
              <!--
              <div>
                <div v-html="(insight.title).charAt(0).toUpperCase()"></div>
              </div>
              -->
              <v-clamp class="title_txt" autoresize :max-lines="2">{{insight.title}}</v-clamp>
            </b-nav-item>
          </b-nav>
        </div>
        <div v-else>No results</div>
      </template>

      <template v-if="currentFacet === 'insights' && showAcademicAlumniInsights">
        <div class="accordion acc_sec">

          <div class="head" role="heading" v-b-toggle="'collapse_AcademicInsights'" variant="primary">
            <div class="ic_container">
              <span class="ic ic-add_circle"></span>
              <span class="ic ic-remove_circle"></span>
            </div>
            <div class="hd_txt">Academic Insights</div>
          </div>

          <b-collapse visible :id="'collapse_AcademicInsights'" class="acc_content">
            <template v-if="academicInsights.length > 0 && isAcademicAlumniInsightFlagsEnabled">
              <b-nav v-for="(insight, index) in academicInsights" v-if="enableInsight(insight.flag)" :key="insight.flag">
                <b-nav-item :title="insight.title" @click="goToReport(insight)">
                  <!--
                  <div>
                    <div v-html="(insight.title).charAt(0).toUpperCase()"></div>
                  </div>
                  -->
                  <v-clamp class="title_txt" autoresize :max-lines="2">{{insight.title}}</v-clamp>
                </b-nav-item>
              </b-nav>
            </template>
            <template v-else class="text-center mt-3 mb-3">No results</template>
          </b-collapse>

        </div>
      </template>


      <template v-if="currentFacet === 'insights' && showCareerAlumniInsights">
        <div class="accordion acc_sec">

          <div class="head" role="heading" v-b-toggle="'collapse_CareerInsights'" variant="primary">
            <div class="ic_container">
              <span class="ic ic-add_circle"></span>
              <span class="ic ic-remove_circle"></span>
            </div>
            <div class="hd_txt">Career Insights</div>
          </div>

          <b-collapse visible :id="'collapse_CareerInsights'" class="acc_content">
            <template v-if="careerInsights.length > 0 && isCareerAlumniInsightFlagsEnabled">
              <b-nav v-for="(insight, index) in careerInsights" v-if="enableInsight(insight.flag)" :key="insight.flag">
                <b-nav-item :title="insight.title" @click="goToReport(insight)">
                  <!--
                  <div>
                    <div v-html="(insight.title).charAt(0).toUpperCase()"></div>
                  </div>
                  -->
                  {{insight.title}}
                </b-nav-item>
              </b-nav>
            </template>
            <template v-else class="text-center mt-3 mb-3">No results</template>
          </b-collapse>

        </div>
      </template>


      <template v-if="currentFacet === 'insights' && showBackgroundAlumniInsights">
        <div class="accordion acc_sec">

          <div class="head" role="heading" v-b-toggle="'collapse_BackgroundInsights'" variant="primary">
            <div class="ic_container">
              <span class="ic ic-add_circle"></span>
              <span class="ic ic-remove_circle"></span>
            </div>
            <div class="hd_txt">Background Insights</div>
          </div>

          <b-collapse visible :id="'collapse_BackgroundInsights'" class="acc_content">
            <template v-if="backgroundInsights.length > 0 && isBackgroundAlumniInsightFlagsEnabled">
              <b-nav v-for="(insight, index) in backgroundInsights" v-if="enableInsight(insight.flag)" :key="insight.flag">
                <b-nav-item :title="insight.title" @click="goToReport(insight)">
                  <!--
                  <div>
                    <div v-html="(insight.title).charAt(0).toUpperCase()"></div>
                  </div>
                  -->
                  <v-clamp class="title_txt" autoresize :max-lines="2">{{insight.title}}</v-clamp>
                </b-nav-item>
              </b-nav>
            </template>
            <template v-else class="text-center mt-3 mb-3">No results</template>
          </b-collapse>

        </div>
      </template>

    </template>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import ExploreInsight from './ExploreInsight'
import VClamp from 'vue-clamp'
export default {
  name: 'explore-insight-list',
  props: ['type', 'isAlumniInsights'],
  components: {
    VClamp,
    ExploreInsight
  },
  data: () => {
    return {
      academicInsights: [
        {
          reportName: 'Popular_Areas_of_Interest',
          targetName: 'Popular_Industries',
          flag: 'showMajorToIndustry',
          title: 'Areas of Interest to Industries',
          type: 'sankey'
        },
        {
          reportName: 'Popular_Areas_of_Interest',
          targetName: 'Popular_Career_Interests',
          flag: 'showMajorToCareer',
          title: 'Areas of Interest to Career',
          type: 'sankey'
        },
        {
          reportName: 'Popular_Majors',
          targetName: 'Popular_Minors',
          flag: 'showMajorToMinor',
          title: 'Majors to Minors',
          type: 'sankey'
        },
        {
          reportName: 'Popular_Courses',
          targetName: '',
          flag: 'showPopularCourses',
          title: 'Popular Courses',
          type: 'bar'
        },
        {
          reportName: 'Popular_Areas_of_Interest',
          targetName: '',
          flag: 'showPopularMajors',
          title: 'Popular Areas of Interest',
          type: 'bar'
        }
      ],
      careerInsights: [
        {
          reportName: '',
          targetName: '',
          flag: 'showFastestGrowingCareers',
          title: 'Fastest Growing Careers (Growth Rate)',
          type: 'fastest-list'
        },
        {
          reportName: '',
          targetName: '',
          flag: 'showCareersWithLargestEmployment',
          title: 'Careers with Largest Employment (# of openings)',
          type: 'largest-list'
        },
        {
          reportName: '',
          targetName: '',
          flag: 'showCareerOptions',
          title: 'Career Options',
          type: 'tree'
        },
        {
          reportName: 'Popular_Industries',
          targetName: '',
          flag: 'showPopularPostGradIndustries',
          title: 'Popular Post Grad Industries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Career_Interests',
          targetName: '',
          flag: 'showPopularCareerInterests',
          title: 'Popular Career Interests',
          type: 'bar'
        },
        {
          reportName: 'Popular_Employers',
          targetName: '',
          flag: 'showPopularPostGradEmployers',
          title: 'Popular Employers',
          type: 'bar'
        },
        {
          reportName: 'Popular_Countries',
          targetName: '',
          flag: 'showPopularPostGradCountry',
          title: 'Popular Post Grad Countries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Job_Titles',
          targetName: '',
          flag: 'showPopularPostGradJobTitles',
          title: 'Popular Post Grad Job Titles',
          type: 'bar'
        }
      ],
      backgroundInsights: [
        {
          reportName: 'Popular_Previous_Industries',
          targetName: '',
          flag: 'showPopularPreviousIndustries',
          title: 'Popular Previous Industries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Job_Areas',
          targetName: '',
          flag: 'showPopularPreviousJobs',
          title: 'Popular Previous Job Areas',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Employers',
          targetName: '',
          flag: 'showPopularPreviousEmployers',
          title: 'Popular Previous Employers',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Countries',
          targetName: '',
          flag: 'showPopularPreviousCountries',
          title: 'Popular Previous Countries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Job_Titles',
          targetName: '',
          flag: 'showPopularPreviousJobTitles',
          title: 'Popular Previous Job Titles',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Education',
          targetName: '',
          flag: 'showPopularPreviousEducation',
          title: 'Popular Previous Education',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Universities',
          targetName: '',
          flag: 'showPopularPreviousUniversities',
          title: 'Popular Previous Universities',
          type: 'bar'
        }
      ],
      selectedInsight: null,
      exploreInsightsFlags: {},
      showSelectedReport: false
    }
  },

  /*
  beforeMount () {
    this.showSelectedReport = this.isAlumniInsights
  },
  */

  mounted () {
    this.setupExploreInsightsFlags()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'setCurrentFacet',
      'loadInstitutionPackage'
    ]),
    async setupExploreInsightsFlags () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      if (this.enabledFeatures) {
        // let firstInsight = this.careerInsights[0]
        let academicInsightsfeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.ACADEMIC_ALUMNI_INSIGHTS_FEATURE_ID]
        if (academicInsightsfeature) {
          let flags = academicInsightsfeature.flags
          for (var i = 0; i < flags.length; i++) {
            let key = flags[i].title
            let value = flags[i].enabled
            this.$set(this.exploreInsightsFlags, key, value)
          }
        }

        let careerInsightsfeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_ALUMNI_INSIGHTS_FEATURE_ID]
        if (careerInsightsfeature) {
          let flags = careerInsightsfeature.flags
          for (var j = 0; j < flags.length; j++) {
            if (this.isAlumniInsights && (flags[j].title === 'showFastestGrowingCareers' || flags[j].title === 'showCareersWithLargestEmployment')) {
              // firstInsight = this.academicInsights[0]
              let key = flags[j].title
              this.$set(this.exploreInsightsFlags, key, false)
            } else {
              let key = flags[j].title
              let value = flags[j].enabled
              this.$set(this.exploreInsightsFlags, key, value)
            }
          }
        }

        let backgroundInsightsfeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BACKGROUND_ALUMNI_INSIGHTS_FEATURE_ID]
        if (backgroundInsightsfeature) {
          let flags = backgroundInsightsfeature.flags
          for (var k = 0; k < flags.length; k++) {
            let key = flags[k].title
            let value = flags[k].enabled
            this.$set(this.exploreInsightsFlags, key, value)
          }
        }
        /*
        if (this.isAlumniInsights) {
          this.goToReport(firstInsight)
        }
        */
      }
    },
    goToReport (insight) {
      this.selectedInsight = insight
      this.setCurrentFacet(this.type)
      this.showSelectedReport = true
    },
    enableInsight (flag) {
      return this.exploreInsightsFlags[flag]
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'currentFacet': state => state.explore.currentFacet,
      'enabledFeatures': state => state.dashboard.enabledFeatures
    }),

    showAcademicAlumniInsights () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.ACADEMIC_ALUMNI_INSIGHTS_FEATURE_ID]
      if (feature && feature.enabled) {
        return true
      }
      return false
    },

    isAcademicAlumniInsightFlagsEnabled () {
      let isEnabled = false
      for (let i = 0; i < this.academicInsights.length; i++) {
        let insight = this.academicInsights[i]
        isEnabled = this.enableInsight(insight.flag)
        if (isEnabled) {
          break
        }
      }
      return isEnabled
    },

    showCareerAlumniInsights () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_ALUMNI_INSIGHTS_FEATURE_ID]
      if (feature && feature.enabled) {
        return true
      }
      return false
    },

    isCareerAlumniInsightFlagsEnabled () {
      let isEnabled = false
      for (let i = 0; i < this.careerInsights.length; i++) {
        let insight = this.careerInsights[i]
        isEnabled = this.enableInsight(insight.flag)
        if (isEnabled) {
          break
        }
      }
      return isEnabled
    },

    showBackgroundAlumniInsights () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BACKGROUND_ALUMNI_INSIGHTS_FEATURE_ID]
      if (feature && feature.enabled) {
        return true
      }
      return false
    },

    isBackgroundAlumniInsightFlagsEnabled () {
      let isEnabled = false
      for (let i = 0; i < this.backgroundInsights.length; i++) {
        let insight = this.backgroundInsights[i]
        isEnabled = this.enableInsight(insight.flag)
        if (isEnabled) {
          break
        }
      }
      return isEnabled
    },

    insightsToShow () {
      var t = []
      t.push(this.careerInsights[0])
      return t
    }

  },

  watch: {
    currentFacet (newCurrentFacet) {
      if (newCurrentFacet !== 'insights') {
        this.resetInsights()
      }
    }
  }
}
</script>

<style scoped>
  .insight-type-head {
    margin-bottom: 12px;
    min-width: 325px;
  }

  .insight-type-status {
    padding: 10px 0px 10px 20px;
    font-size: 18px;
    font-weight: 800;
    color: #ffffff;
  }

  .insight-type-status-circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
    border: 3px solid #fff;
    line-height: 16px;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreInsightList.vue